import { truncate } from 'lodash'
import Image from 'components/image'
import css from '../styles.scss'

interface RegItemProps {
  id: number
  brand: string
  photoUrl: string
  title: string
}

interface RegItemPreviewGridProps {
  regItems: RegItemProps[]
}

const RegItemPlaceholder = () => (
  <div className={css.regItemTile}>
    <div className={css.placeholderImage}>
      <div className={css.shimmer} />
    </div>
    <div style={{ height: 30 }} />
    <div style={{ height: 60 }} />
  </div>
)

export const RegItemPreviewGrid = ({ regItems }: RegItemPreviewGridProps) => {
  const NUM_PLACEHOLDER_REG_ITEMS = 30

  if (regItems.length === 0) {
    const regItemPlaceholders = []
    for (let i = 0; i < NUM_PLACEHOLDER_REG_ITEMS; i += 1) {
      regItemPlaceholders.push(<RegItemPlaceholder key={i} />)
    }
    return <div className={css.previewGrid}>{regItemPlaceholders}</div>
  }

  return (
    <div className={css.previewGrid}>
      {regItems.map((regItem: RegItemProps) => (
        <div className={css.regItemTile} key={regItem.id}>
          <Image className="block" src={regItem.photoUrl} width="100%" />
          <div className="pam">
            <div className="h7 text-muted man pbs">{regItem.brand}</div>
            <div className="h7 man pan">
              {truncate(regItem.title, { length: 38 })}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
